export const USER_IDENTITY = {
  SYS: 1000000,
};
